import btecStaking from "../abis/production/pools/btecStaking";

const host = "https://bscscan.com/address";

export default [
  {
    title: "BTEC Staking",
    contractAddress: "0x056F3336dC183D27FE6785bae037fDb48c77BC71",
    abi: btecStaking.abi,
    minApr: 200,
    url: `${host}/0x056F3336dC183D27FE6785bae037fDb48c77BC71`,
  },
];
